/* eslint-disable react/jsx-sort-props */
import * as React from 'react';
import * as vars from '../../styles/variables';
import AccessibleSVG, { SVGProps } from '../../components/accessible-svg/AccessibleSVG';

/**
 * This is an auto-generated component and should not be edited
 * manually in contributor pull requests.
 *
 * If you have problems with this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Bug_report.md
 *
 * If there are missing features in this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Feature_request.md
 */

const FileNumbers16 = (props: SVGProps) => (
    <AccessibleSVG width={16} height={16} viewBox="0 0 16 16" {...props}>
        <path
            fill={vars.bdlGray50}
            fillRule="evenodd"
            d="M13.744 13.524c.141 0 .256.093.256.207v.063c0 .114-.115.206-.256.206H1.256C1.115 14 1 13.908 1 13.794v-.064c0-.113.115-.206.256-.206h12.488zM7.138 8.321c.062 0 .113.05.113.11V12.9c0 .06-.05.11-.113.11H4.511a.111.111 0 01-.112-.11V8.43c0-.06.05-.11.112-.11h2.627zm-3.275 2.66c.046 0 .084.035.084.077v1.876c0 .042-.038.076-.084.076H1.18c-.046 0-.084-.034-.084-.076v-1.876c0-.042.038-.076.084-.076h2.684zM10.458 3c.062 0 .112.05.112.11v9.79c0 .03-.012.057-.033.078a.118.118 0 01-.08.033H7.83a.112.112 0 01-.112-.111V3.11a.111.111 0 01.113-.111h2.627zm3.33 2.93c.056 0 .101.046.101.103v6.873a.102.102 0 01-.1.104h-2.65a.103.103 0 01-.101-.104V6.033c0-.057.045-.104.1-.104h2.65z"
        />
    </AccessibleSVG>
);

export default FileNumbers16;
